<template>
  <div class="mall-order-fail">
    <div class="page">
      <MallResultMessage
        :icon="resultIcon"
        :title="'결제가 완료되지 않았어요'"
        :messageLines="messageLines"
      />
      <MallBottomBar :buttons="buttons" @click="retry" />
    </div>
  </div>
</template>

<script>
import MallBottomBar from '@/components/new/molecules/MallBottomBar.vue'
import MallResultMessage from '@/components/new/organisms/MallResultMessage.vue'

export default {
  name: 'MallOrderFail',
  components: {
    MallBottomBar,
    MallResultMessage,
  },
  data() {
    return {
      profileId: Number(this.$route.query.profileId) || null,
      // 한 번만 재생되는 애니메이션 이미지 (재생이 끝난 이미지는 다시 재생되지 않아 진입할 때마다 주소를 다르게 함)
      resultIcon: require('@/assets/mall/img_result_alert.webp') + '?t=' + Date.now(),
      // 서버 오류 문구 (예: '다른 결제가 진행 중입니다'), 없으면 기본 문구
      serverMessage: this.$route.query.message || '',
      buttons: [
        { key: 'retry', label: '다시 시도하기', type: 'primary' },
      ],
    }
  },
  computed: {
    messageLines() {
      return this.serverMessage ? [this.serverMessage] : ['결제 중 문제가 발생했어요.', '다시 시도해 주세요.']
    },
  },
  mounted() {
    ChannelIO('shutdown')
  },
  methods: {
    retry() {
      // 구매하기 화면으로 돌아가 결제 준비(checkout)부터 다시 진행
      this.$router.replace({ path: '/mall/order', query: { profileId: this.profileId } })
    },
  },
}
</script>

<style scoped>
  .mall-order-fail {
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: flex-start;
  }
  /* 하단 고정 버튼 영역 위에서 가운데 정렬 - Figma(360x780) 기준 위치(상태바 제외 207px)에 맞춤 */
  .page {
    display: flex;
    width: 100%;
    min-height: 100vh;
    padding: 0 32px 117px 32px;
    flex-direction: column;
    justify-content: center;
    background: #FFF;
    box-sizing: border-box;
  }
  @media (min-width: 600px) {
    .page {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/MallOrderFail.vue